import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY, breakpoints} from "@next/ux-fabric"

type AnchorProps = {
    linkColour: string | null
    fontWeight: string
    isDirectLink: boolean
}

export const Container = styled("li", {
    shouldForwardProp: prop => !["linkColour", "fontWeight", "isDirectLink"].includes(prop as any),
})<AnchorProps>`
    display: flex;
    list-style: none;
    width: 100%;

    a {
        display: flex;
        justify-content: space-between;
        text-decoration: none;
        //Not removing the conditional check of the isDirectLink. When the designs are given for the direct links the correct value can be added
        font-size: ${({isDirectLink, theme: {uxfabric}}) =>
            isDirectLink ? uxfabric.component.listItemSubtitle1.fontSize : uxfabric.global.body2.fontSize};
        line-height: ${({theme}) => theme.uxfabric.global.body2.lineHeight};
        letter-spacing: ${({theme}) => theme.uxfabric.global.body2.letterSpacing};
        word-break: break-word;
        color: ${({theme, linkColour}) => linkColour || theme.uxfabric.components.link.inherit.enabled.textColor};
        font-family: ${({theme: {uxfabric}, isDirectLink}) =>
            isDirectLink
                ? `${uxfabric.component.listItemSubtitle1.fontFamily}, ${FALLBACK_FONT_FAMILY}`
                : `${uxfabric.global.body2.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
        //Not removing the conditional check of the isDirectLink. When the designs are given for the direct links the correct value can be added
        font-weight: ${({theme, fontWeight, isDirectLink}) =>
            fontWeight ||
            (isDirectLink
                ? theme.uxfabric.component.listItemSubtitle1.fontWeight
                : theme.uxfabric.global.body2.fontWeight)};

        @media (min-width: ${breakpoints.values.lg}px) {
            font-size: ${({theme}) => theme.uxfabric.global.body2.fontSize};
            font-weight: ${({theme, fontWeight}) => fontWeight || theme.uxfabric.global.body2.fontWeight};
        }
    }

    a:hover {
        text-decoration: underline;
    }

    @media (min-width: ${breakpoints.values.xs}px) {
        padding: 0 0.5rem 0 0;
        padding-right: ${props => props.isDirectLink && 0};
    }

    @media (min-width: ${breakpoints.values.sm}px) {
        width: ${({isDirectLink}) => (isDirectLink ? "100%" : "50%")};
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        width: 100%;
        line-height: 1.5;
        margin-bottom: 0.5rem;
        padding: 0;
    }
`

export const ItemHref = styled("a", {shouldForwardProp: p => p !== "isDirectLink"})<{isDirectLink: boolean}>`
    width: ${({isDirectLink}) => (isDirectLink ? "100%" : "auto")};
    @media (max-width: ${breakpoints.values.lg}px) {
        padding: 0.375rem 0;
    }
`

export const TitleContainer = styled("span")<{isDirectLink: boolean; isFirstElement: boolean}>`
    display: flex;
    align-items: center;
    letter-spacing: normal;
    margin-top: ${({isFirstElement}) => (isFirstElement ? "1.5" : "0")}rem;

    @media (min-width: ${breakpoints.values.lg}px) {
        height: inherit;
    }
    text-transform: ${({theme}) => theme.uxfabric.global.body2.textTransform};
    font-weight: inherit;
    font-size: inherit;
    font-family: ${({theme: {uxfabric}, isDirectLink}) =>
        isDirectLink
            ? `${uxfabric.component.listItemSubtitle1.fontFamily}, ${FALLBACK_FONT_FAMILY}`
            : `${uxfabric.global.body2.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important; // This is to override MVC changes
`

export const IconContainer = styled("div")`
    display: flex;
    justify-content: space-around;
    width: 2.75rem;
    height: 2.75rem;
    align-self: center;
`

export const TitleAndImageContainer = styled("div")`
    display: flex;
    align-items: center;
`

export const TitleWrapper = styled("a")`
    text-decoration: none;
    color: inherit;
`
